<template>
    <form class="tags-dialog new-item control-container" action="">
        <div class="modal-card" style="width: auto; height:100%">
                <h3>Add an item</h3>
            <Dropdown v-bind:dropdown="dropdown"></Dropdown>

                <b-field >
                    <b-input
                        v-model="dropdown.selection.value"
                        placeholder="Enter your value"
                        required>
                    </b-input>
                </b-field>
                    <button class="button add" type="button" @click="onAddNewItem()">
                    <v-icon left small class="add" color="#4A6EE0">add</v-icon>
                    Add
                </button>
        </div>
    </form>
</template>
    


<script>
import Dropdown from './Dropdown';
export default {
    name: 'ModalForm',
    components: {
        Dropdown
    },
  data() {
      return {
          dropdown: {
              selection: {value:'',type:null},
              defaultText: 'Select a type', 
              items: this.$store.state.typeItems 
            }
      }
  },
    methods: {
        onAddNewItem() {
            this.$emit('update-new-item', this.dropdown.selection)
            this.$parent.close()
        }
    }

}
</script>

<style scoped>
.tags-dialog{
    background: white;
}

.dropdown{
  padding:0px 11px;
  font-size: 14px
}
.modal-card-body{
    z-index: 10;
    overflow: visible;
    position: relative;
}

.modal-card-foot{
    z-index: 5;
    position: relative;
}
.button.add{
    border: 0px;
    color: #4A6EE0;
    background: white;
    font-size: 12px;
    width: 65px!important;
    padding: 0px;
    margin: 0px;
    text-align: left;
    bottom: 5px;
    position: absolute;
}
</style>

<style>
.new-item .dropdown-menu {
      padding: 0px 17px!important;
}
</style>
